import { FC } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { Autocomplete, TextField, TextFieldProps, Typography } from '@mui/material';
import { AGENT_ROLES } from '~/constants/agent_roles';
import SvgIconStyle from '../SvgIconStyle';

type Props = {
  name: string;
  label: string;
};

const RHFRoleSelect: FC<Props & TextFieldProps> = ({ name, label, ...other }) => {
  const { control, setValue, getValues } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Autocomplete
          autoHighlight
          selectOnFocus
          clearOnEscape
          options={AGENT_ROLES}
          disabled={other.disabled}
          value={AGENT_ROLES.find((role) => role.value === getValues(field.name)) || null}
          defaultValue={AGENT_ROLES.filter((role) => role.value === getValues(field.name))[0]}
          getOptionLabel={(option) => option.label}
          onChange={(_event, newValue) => setValue(field.name, newValue?.value || '')}
          popupIcon={<SvgIconStyle src="/icons/ic_expand_more.svg" />}
          renderOption={(props, option) => (
            <li {...props}>
              <Typography key={label} component="span" variant="subtitle2" fontWeight={400}>
                {option.label}
              </Typography>
            </li>
          )}
          renderInput={(params) => <TextField label={label} {...params} {...other} {...field} />}
        />
      )}
    />
  );
};

export default RHFRoleSelect;
